import { Divider, Flex, Table } from 'antd'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { useQuestionnairesServiceGetQuestionnaireSharedListEndpoint } from 'src/api/queries'
import { QuestionnaireState } from 'src/api/requests'
import { SearchBar, Select, Text } from 'src/components'
import { useConfig } from 'src/features/persons/components/PersonQuiz/hooks'
import { useStyles } from 'src/features/persons/styles'
import { useDefaultSortingItem, useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'
import { resetPagination } from 'src/utils'

export const QuizPage = () => {
  const [search, setSearch] = useState('')
  const [isShared, setIsShared] = useState('')

  const { styles } = useStyles()

  const { id } = useParams()
  const { t } = useLocales()

  const pagination = useTablePagination()
  const { defaultSortingOption } = useDefaultSortingItem()

  const { columns } = useConfig()

  const queryParams = {
    pageNumber: Number(pagination.current),
    pageSize: Number(pagination.pageSize),
    personId: String(id),
    ...(!!search && {
      searchTerm: search
    }),
    sharedOnly: Boolean(isShared),
    states: [QuestionnaireState.ACTIVE]
  }

  const { data, isLoading } =
    useQuestionnairesServiceGetQuestionnaireSharedListEndpoint(queryParams)

  const statusOptions = [
    defaultSortingOption,
    {
      label: t('questionnaires.quiz_shared'),
      value: 'true'
    },
    {
      label: t('questionnaires.quiz_not_shared'),
      value: 'false'
    }
  ]

  const onSearch = (val: string) => {
    setSearch(val)
    resetPagination(pagination)
  }

  const onSelect = (val: string) => {
    setIsShared(val)
    resetPagination(pagination)
  }

  return (
    <Flex vertical>
      <Flex justify="space-between">
        <Text className={styles.text}>{t('persons.person_quiz')}</Text>

        <Flex gap={8}>
          <SearchBar
            onSearch={onSearch}
            placeholder={t('questionnaires.search_by_title')}
          />

          <Select
            options={statusOptions}
            onChange={(val: string) => onSelect(val)}
          />
        </Flex>
      </Flex>

      <Divider />

      <Table
        bordered
        rowKey="id"
        columns={columns}
        loading={isLoading}
        dataSource={data?.data}
        pagination={{
          ...pagination,
          total: data?.totalCount
        }}
      />
    </Flex>
  )
}
